// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import { NotificationType } from '@/vue3/api/models/notificationModels';

import { notificationBanner } from '@/vue3/composables/useBannerNotification';

export const useNotificationService = () => {
    const { apiUrl } = useStore().state;
    const store = useStore();
    const axios = useAxios();

    // notification - As USER (Even Admins for their own notifications)

    const getNotificationLatestCountAsUser = async () => {
        const { status, data: {count, banner} } = await axios.get(
            `${store.state.apiUrl}/notification/u/latest`,
        );
        if (status == 200) {
            store.commit('setNotificationCount', `${count}`);
            if(banner && banner.isActive){
                notificationBanner.show(banner);
            } else {
                notificationBanner.hide();
            }
        }
    };

    const getNotificationAsUser = async (id: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/notification/u/${id}`);
        return res.data;
    };

    const getAllNotificationAsUser = async (): Promise<any[]> => {
        const res = await axios.get(`${apiUrl}/notification/u`);
        return res.data;
    };

    const markNotificationSeen = async (
        notificationId: number,
    ): Promise<any> => {
        const res = await axios.post(`${apiUrl}/notification/u`, {
            notificationId,
        });
        if (res.status == 200 || res.status == 201) {
            return true;
        }
        return false;
    };

    const markNotificationUnseen = async (
        notificationId: number,
    ): Promise<any> => {
        const res = await axios.put(`${apiUrl}/notification/u`, {
            notificationId,
        });
        if (res.status == 200) {
            return true;
        }
        return false;
    };

    const deleteNotificationAsUser = async (id: number): Promise<any> => {
        const res = await axios.deleteId(`${apiUrl}/notification/admin/${id}`);
        return res.data;
    };

    // notification - As ADMIN (Managing notifications)
    const getNotificationAsAdmin = async (id: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/notification/admin/${id}`);
        return res.data;
    };

    const getAllNotificationAsAdmin = async (): Promise<any[]> => {
        const res = await axios.get(`${apiUrl}/notification/admin`);
        return res.data;
    };

    const createNotificationAsAdmin = async (
        notificationType: NotificationType,
    ): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/notification/admin`,
            notificationType,
        );
        if (res.status == 200 || res.status == 201) {
            return true;
        }
        return false;
    };

    const updateNotificationAsAdmin = async (
        notificationType: NotificationType,
    ): Promise<any> => {
        const res = await axios.put(
            `${apiUrl}/notification/admin`,
            notificationType,
        );
        if (res.status == 200) {
            return true;
        }
        return false;
    };

    const deleteNotificationAsAdmin = async (id: number): Promise<any> => {
        const res = await axios.deleteId(`${apiUrl}/notification/admin/${id}`);
        if (res.status == 200) {
            return true;
        }
        return false;
    };

    // notification_type - As ADMIN (Managing notification types)
    const getNotificationType = async (
        id: number,
    ): Promise<NotificationType> => {
        const res = await axios.get(`${apiUrl}/notification/type/${id}`);
        return res.data;
    };

    const getAllNotificationType = async (): Promise<NotificationType[]> => {
        const res = await axios.get(`${apiUrl}/notification/type`);
        return res.data;
    };

    const createNotificationType = async (
        notificationType: NotificationType,
    ): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/notification/type`,
            notificationType,
        );
        if (res.status == 200 || res.status == 201) {
            return true;
        }
        return false;
    };

    const updateNotificationType = async (
        notificationType: NotificationType,
    ): Promise<any> => {
        const res = await axios.put(
            `${apiUrl}/notification/type`,
            notificationType,
        );
        if (res.status == 200 || res.status == 201) {
            return true;
        }
        return false;
    };

    const deleteNotificationType = async (id: number): Promise<any> => {
        const res = await axios.deleteId(`${apiUrl}/notification/type/${id}`);
        if (res.status == 200) {
            return true;
        }
        return false;
    };

    const setNotificationBanner = async (banner: any): Promise<any> => {
        const res = await axios.post(`${apiUrl}/notification/banner`, banner);
        if(res.data){
            return res.data;
        }
        return false;
    };

    const getNotificationBanner = async (): Promise<any> => {
        const res = await axios.get(`${apiUrl}/notification/banner`, 
                0, 
                {"bypassAuthCheck":true});
        if(res.data){
            return res.data;
        }
        return false;
    };

    return {
        getNotificationLatestCountAsUser,
        getNotificationAsUser,
        getAllNotificationAsUser,
        markNotificationSeen,
        markNotificationUnseen,

        getNotificationAsAdmin,
        getAllNotificationAsAdmin,
        createNotificationAsAdmin,
        updateNotificationAsAdmin,
        deleteNotificationAsAdmin,

        getNotificationType,
        getAllNotificationType,
        createNotificationType,
        updateNotificationType,
        deleteNotificationType,

        setNotificationBanner,
        getNotificationBanner,
    };
};
